// client/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from './context/AuthContext'; // Import the provider
import NavigationBar from './components/Navbar';
import Footer from './components/Footer';
import AdForm from './components/AdForm';
import EditAdForm from './components/EditAdForm';
import Login from './components/Login';
import Register from './components/Register';
import AdList from './components/AdList';
import './styles.css';

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="app-wrapper">
          <NavigationBar />
          <div className="container main-content mt-4">
            <Routes>
              <Route path="/" element={<AdList />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/create-ad" element={<AdForm />} />
              <Route path="/edit-ad/:id" element={<EditAdForm />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;